///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2025, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2025 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { Viewer } from "../../Viewer";

export class ZoomAction {
  private _m_module: any;
  private _subject: Viewer;

  constructor(m_module: any, subject: Viewer) {
    this._m_module = m_module;
    this._subject = subject;
  }

  public action(x: number, y: number, zoomFactor: number, absoluteX: number, absoluteY: number) {
    const viewer = this._m_module.getViewer();
    viewer.zoomAt(zoomFactor, x, y);

    this._subject.deviceAutoRegeneration();

    this._subject.activeDragger()?.updatePreview?.();
    this._subject.emitEvent({
      type: "zoomat",
      data: zoomFactor,
      x: absoluteX,
      y: absoluteY,
    });
    this._subject.emitEvent({
      type: "changecamera",
    });
  }
}
